<template>
  <main class="flex justify-center w-full font-zona">
    <div class="w-full max-w-[980px] mx-auto px-3 sm:px-0 py-6 sm:py-10">
      <section class="mb-8 sm:mb-10">
        <h1 class="font-bold uppercase text-xl sm:text-2xl text-[#1f1f1f]">
          {{
            lang === "mn"
              ? "ОЛОН УЛСЫН ХАМТЫН АЖИЛЛАГАА"
              : "INTERNATIONAL COOPERATION"
          }}
        </h1>
      </section>

      <section
        v-for="article in articles"
        :key="article.id"
        class="mb-12 sm:mb-16"
      >
        <div class="flex justify-center mb-5 sm:mb-6">
          <img
            :src="article.logo"
            :alt="article.title"
            class="max-w-full h-auto object-contain"
          />
        </div>

        <img
          v-if="article.images[0]"
          :src="article.images[0]"
          :alt="article.title"
          class="w-full h-auto object-cover mb-4"
        />

        <div class="mt-5 sm:mt-6 text-[#2b2b2b]">
          <p
            v-for="(paragraph, index) in article.paragraphs"
            :key="`p1-${index}`"
            class="text-justify text-sm sm:text-[15px] leading-7 mb-3"
          >
            {{ paragraph }}
          </p>

          <div class="mt-4">
            <h3 class="font-bold text-sm sm:text-[15px] mb-2">
              {{ article.subTitle }}
            </h3>

            <ul class="list-disc pl-5 sm:pl-6">
              <li
                v-for="(item, index) in article.points"
                :key="`point-${index}`"
                class="text-sm sm:text-[15px] leading-7"
              >
                <strong>{{ item.label }}</strong> {{ item.text }}
              </li>
            </ul>
          </div>

          <p
            v-for="(paragraph, index) in article.paragraphs2"
            :key="`p2-${index}`"
            class="text-justify text-sm sm:text-[15px] leading-7 mt-3"
          >
            {{ paragraph }}
          </p>
        </div>

        <img
          v-if="article.images[1]"
          :src="article.images[1]"
          :alt="article.title"
          class="w-full h-auto object-cover mt-5 sm:mt-6"
        />
      </section>
    </div>
  </main>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

import img1 from "../../../assets/images/miningMongolia/international-cooperation/img1.png";
import img2 from "../../../assets/images/miningMongolia/international-cooperation/img2.png";
import img3 from "../../../assets/images/miningMongolia/international-cooperation/img3.png";
import img4 from "../../../assets/images/miningMongolia/international-cooperation/img4.png";
import img5 from "../../../assets/images/miningMongolia/international-cooperation/img5.png";
import img6 from "../../../assets/images/miningMongolia/international-cooperation/img6.png";
import logo1 from "../../../assets/images/miningMongolia/international-cooperation/logo1.png";
import logo2 from "../../../assets/images/miningMongolia/international-cooperation/logo2.png";
import logo3 from "../../../assets/images/miningMongolia/international-cooperation/logo3.png";
import logo4 from "../../../assets/images/miningMongolia/international-cooperation/logo4.png";

export default {
  name: "News_1",
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const articlesMongolian = [
      {
        id: 1,
        title: "Тогтвортой уул уурхайн төлөө стандартын хэрэгжилт",
        logo: logo1,
        images: [img1, img2],
        paragraphs: [
          '"Уул уурхайн 7 хоног" чуулган болон "MinePro" үзэсгэлэнгийн үеэр Монголын Уул Уурхайн Үндэсний Ассоциаци (МУУҮА) Канадын уул уурхайн ассоциацийн боловсруулсан "Тогтвортой Уул Уурхайн Төлөө" (TSM) стандартад албан ёсоор нэгдлээ.',
          "Уг түүхэн баримт бичигт МУУҮА-ийн Зөвлөлийн дарга, доктор Г.Батцэнгэл болон Канадын уул уурхайн ассоциацийн Ерөнхийлөгч бөгөөд Гүйцэтгэх захирал Пьер Граттон нар гарын үсэг зурж, баталгаажуулав.",
        ],
        paragraphs2: [
          " Энэхүү алхам нь Монгол Улсын эрдэс баялгийн салбарыг олон улсын хөрөнгө  оруулагчдын өмнө илүү нээлттэй, хариуцлагатай, тогтвортой хөгжлийн баримжаатай  болохыг гэрчилж буй түүхэн үйл явдал юм",
        ],
        subTitle: "TSM стандартын ач холбогдол:",
        points: [
          {
            label: "Хариуцлагатай уул уурхай:",
            text: "Байгаль орчин, нийгмийн хариуцлагыг олон улсын түвшинд хүргэх.",
          },
          {
            label: "Ил тод байдал:",
            text: "Салбарын үйл ажиллагааны тайлагнал, хяналтыг сайжруулах.",
          },
          {
            label: "Дэлхийн жишиг:",
            text: "МУУҮА нь энэхүү нэр хүндтэй стандартад нэгдсэн дэлхийн 12 дахь ассоциаци болж байна.",
          },
        ],
      },
      {
        id: 2,
        title:
          "БНХАУ-ын Уул уурхайн ассоциацитай хамтын ажиллагааны санамж бичиг байгууллаа",
        logo: logo2,
        images: [img3, img4],
        paragraphs: [
          "Монголын Уул Уурхайн Үндэсний Ассоциаци (МУУҮА) болон Хятадын Уул Уурхайн  Ассоциаци хоёр улсын уул уурхайн салбарын урт хугацааны, тогтвортой хамтын  ажиллагааг өргөжүүлэх санамж бичигт гарын үсэг зурж, түүхэн түншлэлийн  эхлэлийг тавилаа.",
          "Энэхүү ёслолын үйл ажиллагаанд МУУҮА-ийн Гүйцэтгэх  захирал Г.Эрдэнэтуяа, Хятадын Уул уурхайн ассоциацийн Ерөнхийлөгч Чэн Ливэй  болон хоёр улсын салбарын яамдын (АҮЭБЯ-ны Төрийн нарийн бичгийн дарга  С.Жавхланбаатар, БНХАУ-ын Байгалийн баялгийн яамны дэд сайд Сюй Дачун  тэргүүтэй) өндөр дээд түвшний төлөөллүүд оролцов.",
        ],
        paragraphs2: [
          "Энэхүү санамж бичиг нь зах зээлийн чиг хандлага, төслийн шинэчлэлүүдээ хуваалцах нэгдсэн платформыг бий болгож, хоёр улсын салбарын харилцааг бэхжүүлсэн, хамтын өсөлт, тогтвортой хөгжлийг дэмжсэн чухал алхам болж байна.",
        ],

        subTitle: "Хамтын ажиллагааны үндсэн чиглэлүүд:",
        points: [
          {
            label: "Мэдээлэл солилцоо:",
            text: "Уул уурхайн бодлого, хууль эрх зүйн орчны туршлага солилцоно.",
          },
          {
            label: "Хөрөнгө оруулалт, төсөл:",
            text: "Хайгуул болон уул уурхайн төслүүдэд хамтарсан хөрөнгө оруулалтыг дэмжинэ.",
          },
          {
            label: "Технологи ба инноваци:",
            text: "Дэвшилтэт технологи болон шилдэг туршлагыг харилцан нэвтрүүлнэ.",
          },
          {
            label: "Хүний нөөцийн хөгжил:",
            text: "Сургалт, боловсролын хөтөлбөрөөр дамжуулан мэргэжлийн ур чадварыг нэмэгдүүлнэ.",
          },
        ],
      },
    ];

    const articlesEnglish = [
      {
        id: 1,
        title:
          "Mongolia begins implementation of the “Towards Sustainable Mining” (TSM) international standard",
        logo: logo3,
        images: [img5, img2],
        paragraphs: [
          "During the “Mining Week” conference and the “MinePro” exhibition, the  Mongolian National Mining Association (MNMA) officially joined the “Towards  Sustainable Mining” (TSM) standard, developed by the Mining Association of Canada.",
          "This historic agreement was formally signed by Dr.Battsengel Gotov, Chairman of the Board of MNMA, and Pierre Gratton, President  and CEO of the Mining Association of Canada.",
        ],
        paragraphs2: [
          "This milestone marks a significant step in positioning Mongolia’s mining sector as more open, responsible, and aligned with sustainable development principles in the eyes of international investors.",
        ],
        subTitle: "Significance of the TSM Standard:",
        points: [
          {
            label: "Responsible Mining:",
            text: "Elevates environmental and social responsibility to international standards.",
          },
          {
            label: "Transparency:",
            text: "Enhances reporting, accountability, and oversight within the mining sector.",
          },
          {
            label: "Global Benchmark:",
            text: "MNMA becomes the 12th association globally to adopt this prestigious standard.",
          },
        ],
      },
      {
        id: 2,
        title:
          "Memorandum of Understanding signed with the China Mining Association",
        logo: logo4,
        images: [img6, img4],
        paragraphs: [
          "The Mongolian National Mining Association (MNMA) and the China Mining Association signed a Memorandum of Understanding (MoU), marking the beginning of a historic partnership aimed at expanding long-term and sustainable cooperation between the mining sectors of the two countries.",
          "The signing ceremony was attended by high-level representatives, including Mrs.Erdenetuya Ganbold, CEO of MNMA; Mr.Chen Liwei, President of the China Mining  Association; as well as senior officials from both countries’ relevant  ministries, including Mr. Javkhlanbaatar S., State Secretary of the Ministry of Industry and Mineral Resources of Mongolia, and Mr.Xu Dachun, Vice Minister of Natural Resources of China.",
        ],
        paragraphs2: [
          "This MoU establishes a unified platform for sharing market trends and project developments, strengthens bilateral cooperation in the mining sector, and represents an important step toward promoting mutual growth and sustainable development.",
        ],
        subTitle: "Key Areas of Cooperation:",
        points: [
          {
            label: "Information Exchange:",
            text: "Sharing experiences related to mining policies and legal frameworks.",
          },
          {
            label: "Investment:",
            text: "Promoting and supporting joint investments in exploration and mining projects.",
          },
          {
            label: "Technology and Innovation:",
            text: "Exchanging advanced technologies and best practices.",
          },
          {
            label: "Human Resources:",
            text: "Collaborating on training and educational programs to enhance professional skills.",
          },
        ],
      },
    ];

    const articles = computed(() =>
      lang.value === "mn" ? articlesMongolian : articlesEnglish,
    );

    return {
      lang,
      articles,
    };
  },
};
</script>
